import { DEFAULT_USER_PROFILE_IMAGE } from 'pages/constants/user';
import { UserFormData } from 'types/user';

export const initialValues: UserFormData = {
    id: '',
    email: '',
    profilePicture: DEFAULT_USER_PROFILE_IMAGE,
    firstName: '',
    lastName: '',
    phoneNumber: '',
    address: null,
    password: '',
    confirmationPassword: '',
};
